import { h, FunctionalComponent } from 'preact'
import ChevronDown from './icon-chevron-down'
import ChevronUp from './icon-chevron-up'
import ChevronRight from './icon-chevron-right'
import ChevronLeft from './icon-chevron-left'
import Close from './icon-close'
import Code from './icon-code'
import Article from './icon-content-type-article'
import Answer from './icon-content-type-answer'
import Discussion from './icon-content-type-discussion'
import Question from './icon-content-type-question'
import Idea from './icon-content-type-idea'
import Edit from './icon-edit'
import Email from './icon-email'
import ExternalLink from './icon-external-link'
import InsertPoll from './icon-insert-poll'
import MoreHoriz from './icon-more-horiz'
import Palette from './icon-palette'
import People from './icon-people'
import Platform from './icon-platform'
import Setting from './icon-setting'
import Loader from './loader'
import ArrowDropdown from './icon-arrow-drop-down'
import ArrowDropUp from './icon-arrow-drop-up'
import Lock from './icon-lock'
import Sort from './icon-sort'
import Search from './icon-search'
import Add from './icon-add'
import Eye from './icon-eye'
import EyeCross from './icon-eye-cross'
import ArrowUp from './icon-arrow-up'
import ArrowDown from './icon-arrow-down'
import Trash from './icon-trash'
import Triangle from './icon-triangle'
import AddWidget from './icon-add-widget'

type cssNumber = number | undefined

const icons = {
  'code': Code,
  'chevronDown': ChevronDown,
  'chevronUp': ChevronUp,
  'chevronRight': ChevronRight,
  'chevronLeft': ChevronLeft,
  'close': Close,
  'article': Article,
  'answer': Answer,
  'discussion': Discussion,
  'conversation': Discussion,
  'question': Question,
  'idea': Idea,
  'ideation': Idea,
  'edit': Edit,
  'email': Email,
  'externalLink': ExternalLink,
  'insertPoll': InsertPoll,
  'moreHoriz': MoreHoriz,
  'palette': Palette,
  'people': People,
  'platform': Platform,
  'setting': Setting,
  'loader': Loader,
  'arrowDropdown': ArrowDropdown,
  'arrowDropUp': ArrowDropUp,
  'lock': Lock,
  'sort': Sort,
  'search': Search,
  'add': Add,
  'eye': Eye,
  'eye-cross': EyeCross,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'trash': Trash,
  'triangle': Triangle,
  'addWidget': AddWidget
}

export type IconType = keyof typeof icons

export interface IconProps {
  icon: IconType,
  height?: cssNumber,
  width?: cssNumber,
  size?: cssNumber,
  customClass?: string,
  onClick?: OnClickCallback,
  color?: string
}

export interface IconComponentProps {
  height: cssNumber,
  width: cssNumber,
  customClass: string,
  onClick?: OnClickCallback,
  color?: string
}

export type IconComponentInterface = FunctionalComponent<IconComponentProps>

const Icon = ({
  icon,
  height = undefined,
  width = undefined,
  size = undefined,
  customClass = '',
  onClick = undefined,
  color,
}: IconProps) => {
  let IconComponent: IconComponentInterface = icons[icon]
  return <IconComponent height={height || size} width={width || size} customClass={customClass} onClick={onClick} color={color} />
}

export default Icon
